import { HeaderCellProps } from '../../types';
import { Tooltip } from '@mui/material';

const TotalOnReplicaDatabaseHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <div>Total on Replica Database</div>;
};

export default TotalOnReplicaDatabaseHeaderCell;
